import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { JiraOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';
import { FeatureExposed } from '@/utils/feature-exposed/use-feature-exposed';

import { CreateASiteText } from '../../../components/create-a-site-heading';
import { Headings } from '../../../components/headings';

export const LoggedInJiraNewUser = () => {
	const subheading = (
		<FormattedMessage
			id="siteActivation.loggedInJira.newUser"
			defaultMessage="Sites are the shared space where people organize teams, work, and projects."
		/>
	);
	return (
		<FeatureExposed experimentKey="jfind-1565-sign-up-flow-overlay" group="Test">
			<JiraOverlayTemplate size="sm">
				<div css={containerCss}>
					<Headings main={<CreateASiteText />} sub={subheading} />
					<SiteActivation useContactExpandCohortLogic={true} />
				</div>
			</JiraOverlayTemplate>
		</FeatureExposed>
	);
};

const containerCss = css({
	display: 'flex',
	flexDirection: 'column',
});
